import { ButtonHTMLAttributes, forwardRef } from 'react';

type BtnVariant = 'primary' | 'secondary' | 'dark' | 'ghost';
type BtnSize = 'sm' | 'md';

const VARIANTS: Record<BtnVariant, string> = {
  // Primary = indigo pâle (PAS noir — charter v2 / ADR-030)
  primary: 'bg-accent-light text-accent-text hover:bg-[#C7D2FE] disabled:opacity-50',
  secondary:
    'bg-paper-elevated text-text-primary border border-rule-strong hover:bg-paper-subtle disabled:opacity-50',
  dark: 'bg-ink text-text-on-dark hover:bg-[#2a2a2a] disabled:opacity-50',
  ghost:
    'bg-transparent text-text-secondary hover:bg-paper-subtle hover:text-text-primary disabled:opacity-50',
};

const SIZES: Record<BtnSize, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
};

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: BtnVariant;
  size?: BtnSize;
};

const Btn = forwardRef<HTMLButtonElement, Props>(function Btn(
  { variant = 'primary', size = 'md', className = '', children, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      className={`inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Btn;
